import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { useMounted } from '@hooks';
export function useAsyncSafeState(initialState) {
  const $ = _c(5);
  const isMounted = useMounted();
  const [value, setValue] = React.useState(initialState);
  let t0;
  if ($[0] !== isMounted) {
    t0 = newValue => {
      if (isMounted.current) {
        return setValue(newValue);
      }
    };
    $[0] = isMounted;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const asyncSafeSetValue = t0;
  let t1;
  if ($[2] !== asyncSafeSetValue || $[3] !== value) {
    t1 = [value, asyncSafeSetValue];
    $[2] = asyncSafeSetValue;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1 as const;
}